




































import Vue from 'vue';

export default Vue.extend({
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHovering: false,
    };
  },
  computed: {
    cssClass(): string|null {
      return this.disable ? null : 'drop-zone--enabled';
    },
  },
  watch: {
    disable(disable: boolean) {
      if (disable) {
        this.removeListeners();
      } else {
        this.addListeners();
      }
    },
  },
  methods: {
    openFileBrowser() {
      if (this.disable) return;
      (this.$refs.file as HTMLInputElement).click();
    },
    onDragOver(e: Event) {
      e.stopPropagation();
      e.preventDefault();
      this.isHovering = true;
    },
    onDragLeave(e: Event) {
      e.stopPropagation();
      e.preventDefault();
      this.isHovering = false;
    },
    onPick(e: Event) {
      e.stopPropagation();
      e.preventDefault();
      this.isHovering = false;
      if (e.target === null) return;
      const { files } = (e.target as HTMLInputElement);
      if (files !== null && files.length) {
        this.$emit('drop', files[0]);
      }
    },
    onDrop(e: Event) {
      e.stopPropagation();
      e.preventDefault();
      this.isHovering = false;
      const event = (e as DragEvent);
      if (event.dataTransfer === null) return;
      const { files } = event.dataTransfer;
      if (files.length) {
        this.$emit('drop', files[0]);
      }
    },
    addListeners() {
      this.$el.addEventListener('dragover', this.onDragOver, false);
      this.$el.addEventListener('dragleave', this.onDragLeave, false);
      this.$el.addEventListener('drop', this.onDrop, false);
    },
    removeListeners() {
      this.$el.removeEventListener('dragover', this.onDragOver, false);
      this.$el.removeEventListener('dragleave', this.onDragLeave, false);
      this.$el.removeEventListener('drop', this.onDrop, false);
    },
  },
  mounted() {
    this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
});
